export default "__VITE_ASSET__ByPkH$jP__"